export const days: string[] = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
export const daysNamed: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
